import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SVGFill } from '../../svg';
import { Icon } from '../../icon';
var MergeIcon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Icon, _extends({
    ref: ref
  }, props), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.2546C2 3.46078 3.46078 2 5.2546 2H24C24.5786 2 25.0476 2.46904 25.0476 3.04762C25.0476 3.6262 24.5786 4.09524 24 4.09524H5.2546C4.61795 4.09524 4.09524 4.61795 4.09524 5.2546V42.7454C4.09524 43.382 4.61795 43.9048 5.2546 43.9048H24C24.5786 43.9048 25.0476 44.3738 25.0476 44.9524C25.0476 45.531 24.5786 46 24 46H5.2546C3.46078 46 2 44.5392 2 42.7454V5.2546Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9524 3.04762C22.9524 2.46904 23.4214 2 24 2H42.7454C44.5392 2 46 3.46078 46 5.2546V42.7454C46 44.5392 44.5392 46 42.7454 46H24C23.4214 46 22.9524 45.531 22.9524 44.9524C22.9524 44.3738 23.4214 43.9048 24 43.9048H42.7454C43.382 43.9048 43.9048 43.382 43.9048 42.7454V5.2546C43.9048 4.61795 43.382 4.09524 42.7454 4.09524H24C23.4214 4.09524 22.9524 3.6262 22.9524 3.04762Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6722 20.0465C13.0813 20.4556 13.0813 21.119 12.6722 21.5281L10.2003 24L12.6722 26.4719C13.0813 26.881 13.0813 27.5444 12.6722 27.9535C12.2631 28.3626 11.5998 28.3626 11.1906 27.9535L7.97795 24.7408C7.56883 24.3317 7.56883 23.6683 7.97795 23.2592L11.1906 20.0465C11.5998 19.6374 12.2631 19.6374 12.6722 20.0465Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67111 24C7.67111 23.4214 8.14015 22.9524 8.71873 22.9524H18.3289C18.9075 22.9524 19.3765 23.4214 19.3765 24C19.3765 24.5786 18.9075 25.0476 18.3289 25.0476H8.71873C8.14015 25.0476 7.67111 24.5786 7.67111 24Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.3278 20.0465C35.7369 19.6374 36.4002 19.6374 36.8093 20.0465L40.022 23.2592C40.4312 23.6683 40.4312 24.3317 40.022 24.7408L36.8093 27.9535C36.4002 28.3626 35.7369 28.3626 35.3278 27.9535C34.9187 27.5444 34.9187 26.881 35.3278 26.4719L37.7997 24L35.3278 21.5281C34.9187 21.119 34.9187 20.4556 35.3278 20.0465Z"
  }), /*#__PURE__*/React.createElement(SVGFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6235 24C28.6235 23.4214 29.0925 22.9524 29.6711 22.9524H39.2813C39.8599 22.9524 40.3289 23.4214 40.3289 24C40.3289 24.5786 39.8599 25.0476 39.2813 25.0476H29.6711C29.0925 25.0476 28.6235 24.5786 28.6235 24Z"
  }));
});
MergeIcon.displayName = 'MergeIcon';
MergeIcon.defaultProps = {
  'aria-label': 'Merge'
};
export default MergeIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/theme/dist/esm/icons/MergeIcon/index.js
// module id = 1891
// module chunks = 12